import { NavLink } from 'react-router-dom';

export default function SideList(props) {return (
    	<NavLink to={props.link} className={({isActive}) => isActive ? "active-sidenav" : "my-1 py-1 px-4 hover:bg-neutral-200 dark:hover:bg-neutral-700 hover:underline rounded-lg"}>{props.text}</NavLink>
	)
}